import { SelectionCategories } from '@revelio/iso-utility';

export const SelectionCategoryLabelOverrides: { [key: string]: string } = {
  [SelectionCategories.JOB_CATEGORY]: 'k10',
  [SelectionCategories.ROLE_K50]: 'k50',
  [SelectionCategories.ROLE_K150]: 'k150',
  [SelectionCategories.ROLE_K300]: 'k300',
  [SelectionCategories.ROLE_K500]: 'k500',
  [SelectionCategories.ROLE_K1000]: 'k1000',
  [SelectionCategories.ROLE_K1250]: 'k1250',
  [SelectionCategories.ROLE_K1500]: 'k1500',
  [SelectionCategories.ROLE_K5000]: 'k5000',
  [SelectionCategories.ROLE_K15000]: 'k15000',
  [SelectionCategories.REGION]: 'Region',
  [SelectionCategories.COUNTRY]: 'Country',
  [SelectionCategories.STATE]: 'State',
  [SelectionCategories.METRO_AREA]: 'Metro Area',
  [SelectionCategories.SKILL_K25]: 'k25 ',
  [SelectionCategories.SKILL_K50]: 'k50 ',
  [SelectionCategories.SKILL_K75]: 'k75',
  [SelectionCategories.SKILL_K700]: 'k700',
  [SelectionCategories.SKILL_K3000]: 'k3000',
  [SelectionCategories.SKILL_K150]: 'k150',
  [SelectionCategories.SKILL_K1500]: 'k1500',
  [SelectionCategories.SKILL_K5000]: 'k5000',
  [SelectionCategories.SKILL_K15000]: 'k15000',
  [SelectionCategories.SKILL_K35000]: 'k35000',
  [SelectionCategories.RAW_TITLE]: 'Title',
};
